export default __webpack_public_path__ + "static/media/hammers.9d136c6c.png";